function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "ymhl7igt6c",
  x1: "1.003%",
  x2: "100%",
  y1: "50%",
  y2: "50%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#4A8BC0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#4A8BC0",
  stopOpacity: 0.7
})), /*#__PURE__*/React.createElement("path", {
  id: "g34hdfti9a",
  d: "M20 0c10.796 0 20 9.218 20 20 0 10.796-9.218 20-20 20-3.688 0-7.61-1.057-10.576-2.839L1.028 39.96c-.279.093-.589.021-.8-.189-.208-.209-.281-.519-.188-.8l2.799-8.394C1.057 27.61 0 23.688 0 20 0 9.203 9.22 0 20 0zm0 1.563C10.006 1.563 1.563 10.005 1.563 20c0 3.538 1.044 7.299 2.792 10.06.126.198.156.442.081.664l-2.42 7.26 7.26-2.42c.225-.076.47-.043.665.08 2.76 1.75 6.521 2.794 10.059 2.794 9.994 0 18.438-8.444 18.438-18.438 0-9.994-8.444-18.438-18.438-18.438zm2.344 14.53c.431 0 .781.35.781.782v10.156h.781c.432 0 .782.35.782.782v3.125c0 .431-.35.78-.782.78h-7.812c-.432 0-.781-.349-.781-.78v-3.125c0-.432.35-.782.78-.782h.782v-6.25h-.781c-.432 0-.781-.35-.781-.781v-3.125c0-.432.35-.781.78-.781zm-.781 1.563h-4.688v1.563h.781c.432 0 .782.35.782.781v7.813c0 .431-.35.78-.782.78h-.781v1.563h6.25v-1.562h-.781c-.431 0-.781-.35-.781-.782V17.657zm12.685-5.061c.39-.186.855-.02 1.041.369 1.053 2.209 1.586 4.576 1.586 7.036 0 1.105-.11 2.21-.33 3.281-.075.37-.4.626-.764.626-.052 0-.105-.006-.157-.017-.423-.086-.696-.499-.61-.921.198-.97.299-1.968.299-2.969 0-2.226-.483-4.367-1.434-6.364-.186-.39-.02-.856.369-1.041zM20 8.28c1.723 0 3.125 1.402 3.125 3.125S21.723 14.531 20 14.531s-3.125-1.402-3.125-3.125S18.277 8.281 20 8.281zm0 1.563c-.861 0-1.562.7-1.562 1.562 0 .862.7 1.563 1.562 1.563.862 0 1.563-.701 1.563-1.563 0-.861-.701-1.562-1.563-1.562zm12.969 0c.431 0 .781.35.781.781 0 .431-.35.781-.781.781-.431 0-.781-.35-.781-.781 0-.431.35-.781.78-.781z"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-1461 -841) translate(1174 288) translate(0 64) translate(16 211) translate(16 258) translate(255 20)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "e16yqc730b",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#g34hdfti9a"
})), /*#__PURE__*/React.createElement("use", {
  fill: "#FFF",
  fillRule: "nonzero",
  xlinkHref: "#g34hdfti9a"
}), /*#__PURE__*/React.createElement("g", {
  fill: "url(#ymhl7igt6c)",
  mask: "url(#e16yqc730b)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0H40V40H0z"
})))))))));

var SvgIcnBigInfoBlue = function SvgIcnBigInfoBlue(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcnBigInfoBlue, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icn-big-info-blue.f4879cd3.svg";
export { ForwardRef as ReactComponent };